import 'whatwg-fetch';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { setOptions, overrideComponent } from '@sheerid/jslib';
import './index.css';
import App from './App';
import { StepSuccessComponent } from './components/StepSuccessComponent';
import { StepDocUploadComponent } from './components/StepDocUploadComponent';
import { StepFirstResponderPersonalInfoComponent } from './components/StepFirstResponderPersonalInfoComponent';

setOptions({
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    messagesWithLocale: {
        'en-US' : {
            errorId: {
                fraudRulesReject: 'We\'re glad you\'re enthusiastic, but it looks like you\'ve already redeemed or attempted to redeem this offer.',
                internalServerError: 'Internal server error',
                noRemainingRewardCodes: "Sorry, this offer is closed and we can't verify you at this time. Please try again later.",
                noProgram: 'No program found',
                noVerification: 'No verification found',
                expiredProgram: 'This link is no longer active',
                invalidProgram: 'Invalid program',
                invalidStep: 'Invalid step',
                invalidMilitaryStatus: 'Invalid military status',
                invalidFirstResponderStatus: 'Invalid first responder status',
                invalidOrganization: 'You must select an organization from the list',
                invalidFirstName: 'Invalid first name',
                invalidLastName: 'Invalid last name',
                invalidBirthDate: 'Invalid birth date',
                invalidMemberId: 'Invalid ID Number',
                invalidEmail: 'Invalid email',
                invalidPostalCode: 'Invalid postal code',
                invalidAddress: 'Invalid address',
                invalidCity: 'Invalid city',
                invalidPhoneNumber: 'Invalid mobile number',
                invalidCountry: 'Invalid country',
                invalidState: 'Invalid state',
                underagePerson: 'Persons under age 16 are not eligible for this offer.',
                outsideAgePerson: 'Age outside allowed range',
                futureBirthDate: 'Future birthdate',
                unsupportedDocMimeType: 'One or more files is an unsupported format',
                invalidFileSizeEmpty: 'One or more files is empty',
                invalidFileSizeMax: 'One or more files is too large (max: 10MB)',
                invalidNumberOfFiles: 'Maximum number of files exceeded (max: 5)',
                invalidDocUploadToken: 'Provided document upload token is not valid',
                verificationLimitExceeded: 'We\'re glad you\'re enthusiastic, but it looks like you\'ve already redeemed or attempted to redeem this offer.',
                apiRateLimitExceeded: 'Unable to process your request at this time, please try again later',
                docReviewLimitExceeded: 'Document review limit exceeded',
                maxMetadataValuesExceeded: 'Maximum number of metadata values exceeded',
                maxMetadataLengthExceeded: 'Maximum length of metadata value exceeded',
                unknownError: 'Unknown Error',
                invalidRequest: 'Invalid request',
                invalidApiToken: 'Provided API token was invalid or empty',
                simulatedError: 'This is a simulated error',
                notFound: 'Not found',
                unauthorizedDomain: 'Unauthorized domain',
            },
            step: {
                personalInfo: {
                    title: 'Verify your details',
                    subtitle: 'Complete the form below to confirm your eligibilty.',
                },
                docUpload: {
                    submitButtonLabel: 'SUBMIT FOR REVIEW',
                    title: 'Upload Documentation',
                    clickHere: 'click here',
                    subtitle: 'To complete verification, please submit any document that clearly shows your name and your first responder status.',
                    docDisplay: 'Important - Your document must display the following:',
                    uploadDocFullName: 'Your full name',
                    uploadDocOrg: 'Your organization',
                    uploadDocAffiliation: 'Your affiliation',
                    uploadDocIfName: 'If your name or organization are not correct, please ',
                    uploadDocAreNotCorrect: ' to enter your information again.',
                    uploadDocAcceptableDocs: 'Examples of acceptable documents are:',
                    uploadDocIdCard: 'ID Card',
                    uploadDocPayStub: 'Pay stub dated within 60 days',
                    uploadDocOfficialDoc: 'Any official document that clearly shows your first/last name, current date, and status as a First Responder',
                    uploadDocAcceptableFormats: 'Acceptable formats are: ',
                    uploadDocFormatTypes: '.bmp, .gif, .jpg, .png, or .pdf.',
                    fileInstructions: 'Choose file',
                    uploadDocNoFileSelected: 'No file selected.',
                    addFile: "Add file",
                    uploadDocDocScan: "NOTE: If your document scan is too fuzzy to read, does not show your full and legal name or shows a name different from the one you are verifying this offer under, you will not be able to finalize the verification process. Please do not include any confidential information on the uploaded document, such as social security numbers or banking details. Please be sure any sensitive information is blacked out before you upload your document.",
                },
                pending: {
                    titleReview: 'Upload Success',
                    subtitle: 'Your document has uploaded successfully. The review process has now started. You will be contacted via the email address entered on the verification form in less than 20 minutes with details regarding your verification request.',
                    subtitle2: 'NOTE: If you do not receive an email within the time shown above, you may want to check your junk/spam folder for the message.',
                }
            },
            dateTime: {
                january: 'Jan',
                february: 'Feb',
                march: 'Mar',
                april: 'Apr',
                may: 'May',
                june: 'Jun',
                july: 'Jul',
                august: 'Aug',
                september: 'Sep',
                october: 'Oct',
                november: 'Nov',
                december: 'Dec',
            },
            status: 'CURRENT STATUS',
            organization: 'ORGANIZATION NAME',
            firstName: 'FIRST NAME',
            lastName: 'LAST NAME',
            emailAddress: 'EMAIL ADDRESS',
            birthDate: 'DATE OF BIRTH',
            postalCode: 'POSTAL CODE',
            verifyMyFirstResponderStatus: 'SUBMIT FOR REVIEW',
            firstResponderInfoShared: 'Information entered here will be used for verification purposes and will be shared with Purple. By clicking Submit, you agree to sign up for Purple email marketing. You can unsubscribe at any time.',
        }
    }
});

// @ts-ignore
overrideComponent('StepFirstResponderPersonalInfoComponent', StepFirstResponderPersonalInfoComponent);
overrideComponent('StepSuccessComponent', StepSuccessComponent);
overrideComponent('StepDocUploadComponent', StepDocUploadComponent);


ReactDOM.render(<App />, document.getElementById('root'));
